// eslint-disable-next-line @typescript-eslint/naming-convention
export const PAGINATION_LIMIT = 8
